const padDatePart = (value) => String(value).padStart(2, "0");

const parseLocalDate = (dateValue) => {
  if (dateValue instanceof Date) {
    return new Date(
      dateValue.getFullYear(),
      dateValue.getMonth(),
      dateValue.getDate(),
    );
  }

  if (typeof dateValue === "string") {
    const [year, month, day] = dateValue.slice(0, 10).split("-").map(Number);
    if (year && month && day) {
      return new Date(year, month - 1, day);
    }
  }

  return new Date(dateValue);
};

export const getLocalBookingDateString = (dateValue) => {
  const date = parseLocalDate(dateValue);

  return [
    date.getFullYear(),
    padDatePart(date.getMonth() + 1),
    padDatePart(date.getDate()),
  ].join("-");
};

export const getNextLocalBookingDateString = (dateValue) => {
  const date = parseLocalDate(dateValue);
  date.setDate(date.getDate() + 1);

  return getLocalBookingDateString(date);
};

export const getBookingEventDateInput = (eventData = {}, selectedDate) => {
  const dateValue =
    selectedDate ||
    eventData.startStr ||
    eventData.start ||
    new Date();
  const dateString = getLocalBookingDateString(dateValue);

  return {
    dateString,
    date: new Date(dateString),
  };
};

export const isSameLocalBookingDate = (leftDateValue, rightDateValue) => {
  if (!leftDateValue || !rightDateValue) {
    return false;
  }

  return (
    getLocalBookingDateString(leftDateValue) ===
    getLocalBookingDateString(rightDateValue)
  );
};

export const getBookingDateChangeConfirmation = ({
  order,
  patientName,
  oldDate,
  oldStatus,
  newDate,
  newStatus,
  updatedBy,
}) => {
  if (!oldDate || !newDate) {
    return null;
  }

  const normalizedOldDate = getLocalBookingDateString(oldDate);
  const normalizedNewDate = getLocalBookingDateString(newDate);
  const normalizedOldStatus = String(oldStatus || "").trim();
  const normalizedNewStatus = String(newStatus || "").trim();

  if (
    normalizedOldDate === normalizedNewDate ||
    normalizedOldStatus !== normalizedNewStatus
  ) {
    return null;
  }

  return {
    order: String(order || "").trim() || "-",
    patientName: String(patientName || "").trim() || "-",
    oldDate: normalizedOldDate,
    oldStatus: normalizedOldStatus || "-",
    newDate: normalizedNewDate,
    newStatus: normalizedNewStatus || "-",
    updatedBy: String(updatedBy || "").trim() || "Unknown user",
  };
};
